import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "testId", "overrideUrl"];
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { SmartLinkStatus } from '../../../../../constants';
import PreviewBlockOld from './indexOld';
import PreviewBlockResolvedView from './resolved';
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */
var PreviewBlock = function PreviewBlock(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? SmartLinkStatus.Fallback : _ref$status,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-preview' : _ref$testId,
    overrideUrl = _ref.overrideUrl,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PreviewBlockResolvedView, _extends({}, blockProps, {
    testId: testId,
    overrideUrl: overrideUrl
  }));
};
var Exported = function Exported(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(PreviewBlock, props);
  } else {
    return /*#__PURE__*/React.createElement(PreviewBlockOld, props);
  }
};
export default Exported;